import EnlargeCollapse from './EnlargeCollapse';
import Flash from './Flash';
import Lock from './Lock';
import Menu from './Menu';
import More from './More';
import ToggleLeftSection from './ToggleLeftSection';
import ToggleList from './ToggleList';
import ToggleRightSection from './ToggleRightSection';
export const DefaultIcons = {
    EnlargeCollapse,
    Flash,
    Lock,
    Menu,
    More,
    ToggleLeftSection,
    ToggleList,
    ToggleRightSection,
};
export default DefaultIcons;
